export const LOCALES ={
    PORTUGUESE: 'pt',
    ENGLISH:'en',
}